import React from 'react';
import './css/StatusBadge.css';

const StatusBadge = ({ status, className = '', variant = 'default' }) => {
  const getStatusClass = () => {
    switch (variant) {
      case 'system-users':
        return `system-users-status-badge system-users-status-badge--${status?.toLowerCase()}`;
      default:
        return `status-badge status-badge--${status?.toLowerCase()}`;
    }
  };

  const getStatusText = () => {
    if (!status) return 'Unknown';
    
    switch (status.toLowerCase()) {
      case 'approved':
        return 'Approved';
      case 'rejected':
        return 'Rejected';
      case 'pending':
        return 'Pending';
      case 'enabled':
        return 'Enabled';
      case 'disabled':
        return 'Disabled';
      default:
        return status;
    }
  };

  const badgeClass = `${getStatusClass()} ${className}`.trim();

  return (
    <span className={badgeClass}>
      {getStatusText()}
    </span>
  );
};

export default StatusBadge;
